import { DropdownInput, NumberInput, Switch, TextInput, TextWithButtonInput } from "components/Inputs"

import bairrosAju from "json/BairrosAju.json"
import searchIcon from "assets/searchIcon.png"
import { LineWithText } from "components/FormGerarGuia"
import { autoCompleteEndereco } from "./FormFunctions"

const searchImg = <img src={searchIcon} className="mx-1" width="20px" height="20px" alt="ícone"/>

const opcoesParcelamento = ["Sem parcelamento", "2 vezes", "3 vezes", "4 vezes", "5 vezes", "6 vezes"]

function formatNumProc(numProc) { return numProc.replace(".", "").replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.') }

export const guiaField =
{
    nomeProprietario: () => { return <TextInput Name={"nomeProprietario"} Placeholder={"Fulano da Silva"} Label={"Nome do proprietário"} Value={""} Req={true} Info={""} Mask={null}/> },
    cpfCnpjProprietario: (cpf_cnpjPlaceholder, cpf_cnpjMask) => { return <TextInput Name={"cpfCnpjProprietario"} Placeholder={cpf_cnpjPlaceholder} Label={"CPF / CNPJ"} Value={""} Req={true} Info={""} Mask={cpf_cnpjMask} /> },
    logradouroProprietario: () => { return <TextInput Name={"logradouroProprietario"} Placeholder={"Avenida Augusto Franco"} Label={"Logradouro"} Req={true} Info={"Não coloque o número"} /> },
    nomeRequerente: () => { return <TextInput Name={"nomeRequerente"} Placeholder={"Fulano da Silva"} Label={"Nome do requerente"} Req={true} /> },
    complementoProprietario: () => { return <TextInput Name={"complementoProprietario"} Label={"Complemento"} /> },
    numPortaProprietario: () => { return <TextInput Name={"numPortaProprietario"} Placeholder={"000"} Label={"Número de porta"} Req={true}/> },
    bairroProprietario: (temEnderecoObra) => {
        return temEnderecoObra ? <TextInput Name={"bairroProprietario"} Label={"Bairro"} Req={true} /> :<DropdownInput Name={"bairroProprietario"} ItemsList={bairrosAju} Value={"Bairro"} Req={true} />
    },
    cpfCnpjRequerente: (cpf_cnpjPlaceholder, cpf_cnpjMask) => { return <TextInput Name={"cpfCnpjRequerente"} Placeholder={cpf_cnpjPlaceholder} Label={"CPF / CNPJ"} Req={true} Mask={cpf_cnpjMask} /> },
    numProc: (onBlur) => { return <TextInput Name={"numProc"} Placeholder={"00.000"} Label={"Número do processo"} Req={true} Info={"Número sem o ano"} OnChange={(target) => {target.target.value = formatNumProc(target.target.value)}} OnBlur={onBlur} /> },

    logradouroObra: () => { return <TextInput Name={"logradouroObra"} Placeholder={"Avenida Augusto Franco"} Label={"Endereço"} Req={true} Info={"Logradouro sem o número"} /> },
    numPortaObra: () => { return <TextInput Name={"numPortaObra"} Placeholder={"000"} Label={"Número"} Req={true} Info={"Número de porta"} /> },
    complementoObra: () => { return <TextInput Name={"complementoObra"} Label={"Complemento"} /> },

    anoProc: (onBlur) => { return <NumberInput Name={"anoProc"} Placeholder={"0000"} Label={"Ano do processo"} Req={true} OnBlur={onBlur} /> },


    bairroObra: () => { return <DropdownInput Name={"bairroObra"} ItemsList={bairrosAju} Value={"Bairro"} Req={true} /> },
    parcelasPagamento: () => { return <DropdownInput Name={"parcelasPagamento"} ItemsList={opcoesParcelamento} Value={"Pagamento parcelado"} /> },
    

    switchCNPJ: (onChangeCPFCNPJ) => { return <Switch Name={"switchCNPJ"} Label={"CNPJ"} OnChange={onChangeCPFCNPJ} /> },

    cepProprietario: (handleOnClick) => { return <TextWithButtonInput Name={"cepProprietario"} Placeholder={"49047-040"} Label={"CEP"} ButtonImg={searchImg} Req={true} Mask={"99.999-999"} OnClick={handleOnClick} /> },
    cepObra: (handleOnClick) => { return <TextWithButtonInput Name={"cepObra"} Placeholder={"49047-040"} Label={"CEP"} ButtonImg={searchImg} Req={true} Mask={"99.999-999"} OnClick={handleOnClick} /> },
}


export const section =
{
    dadosProcesso: (onBlur) =>
    {
        return (
            <>
                <LineWithText text={"Dados do processo"} />
                <div className="d-flex">
                    { guiaField.numProc(onBlur) }
                    { guiaField.anoProc(onBlur) }
                </div>
            </>
        )
    },
    dadosProprietario: (switchCNPJ, onChangeCPFCNPJ) =>
    {
        const cpf_cnpjMask = switchCNPJ ? "99.999.999/9999-99" : "999.999.999-99"
        const cpf_cnpjPlaceholder = cpf_cnpjMask
        return (
            <>
                <LineWithText text={"Dados do proprietário"} />            
                <div className="d-flex">
                    <div className="w-50">
                    </div>
                    <div className="w-50">
                        { guiaField.switchCNPJ(onChangeCPFCNPJ) }
                    </div>
                </div>
                <div className="d-flex">
                    { guiaField.nomeProprietario() }
                    { guiaField.cpfCnpjProprietario(cpf_cnpjPlaceholder, cpf_cnpjMask) }
                </div>
            </>
        )
    },
    enderecoObra: (autoCompleteEnderecoObra) =>
    {
        return (
            <>
                <LineWithText text={"Endereço da obra"} />
                { guiaField.cepObra(autoCompleteEnderecoObra) }
                { guiaField.logradouroObra() }
                { guiaField.numPortaObra() }
                { guiaField.complementoObra() }
                { guiaField.bairroObra() }
            </>
        )
    },
    enderecoRequerente: (temEnderecoObra) =>
    {
        return (
            <>
                <LineWithText text={"Endereço do proprietário"} />
                <div className="d-flex"> 
                    { guiaField.cepProprietario(autoCompleteEndereco) }
                </div>
    
                <div className="d-flex justify-content-between">
                    <div className="d-flex flex-column justify-content-end">
                        { guiaField.bairroProprietario(temEnderecoObra) }
                    </div>
                    { guiaField.numPortaProprietario() }
                </div>
    
                { guiaField.logradouroProprietario() }
                { guiaField.complementoProprietario() }
            </>
        )
    },
    parcelamento: () =>
    {
        return (
            <>
                <LineWithText text={"Parcelamento da taxa"} />
                { guiaField.parcelasPagamento() }
            </>
        )
    }
}
                